import { render, staticRenderFns } from "./store-form.vue?vue&type=template&id=6672fa49"
import script from "./store-form.vue?vue&type=script&lang=js"
export * from "./store-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports